import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mobileLeading", "searchForm"];

  static values = {
    inputId: String,
  };

  connect() {
    this.boundSync = this.sync.bind(this);
    document.addEventListener("turbo:load", this.boundSync);
    window.addEventListener("pageshow", this.boundSync);

    this.sync();
    requestAnimationFrame(this.boundSync);
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundSync);
    window.removeEventListener("pageshow", this.boundSync);
  }

  expand(event) {
    event?.preventDefault();
    this.showExpanded();

    requestAnimationFrame(() => this.input?.focus());
  }

  cancel(event) {
    event.preventDefault();

    const hadValue = this.input?.value.trim().length > 0;

    if (this.input) {
      this.input.value = "";
      this.input.blur();
    }

    this.showCollapsed();
    if (hadValue) this.form?.requestSubmit();
  }

  sync() {
    if (this.input?.value.trim().length > 0) this.showExpanded();
    else this.showCollapsed();
  }

  get input() {
    return document.getElementById(this.inputIdValue);
  }

  get form() {
    return this.hasSearchFormTarget ? this.searchFormTarget.querySelector("form") : null;
  }

  showExpanded() {
    if (this.hasMobileLeadingTarget) this.mobileLeadingTarget.classList.add("tw-hidden");
    if (this.hasSearchFormTarget) this.searchFormTarget.classList.remove("tw-hidden");
  }

  showCollapsed() {
    if (this.hasMobileLeadingTarget) this.mobileLeadingTarget.classList.remove("tw-hidden");
    if (this.hasSearchFormTarget) this.searchFormTarget.classList.add("tw-hidden");
  }
}
